import { computed, Directive, effect, inject, input, signal } from '@angular/core';
import { ItemId, itemIdentifierAttribute, ProductComponentStore, ProductEntity, ProductStore } from 'products-data';
import { ProductOrItemComponentBase } from '../ProductOrItemComponentBase';

@Directive()
export abstract class ItemComponentBase extends ProductOrItemComponentBase<ItemId> {
  private readonly _productStore = inject(ProductStore);
  protected readonly product = signal<ProductEntity | null>(null);

  public override readonly id = input.required({
    alias: 'itemId',
    transform: itemIdentifierAttribute,
  });
  public readonly itemOptions = computed(() => this.id()?.options ?? null);
  public readonly productType = computed(() => this.id()?.type ?? null);

  protected readonly thumbnailUrl = computed(() => this.product()?.thumbnail ?? '');

  constructor() {
    super();

    effect(() => {
      const productId = this.productId();
      if (productId) {
        const prdSig = this._productStore.getProduct(productId);
        this.product.set(prdSig() ?? null);
      } else {
        this.product.set(null);
      }
    });
  }
}
